module.exports = __webpack_public_path__ + "img/woman.fd554afb.svg";